import { Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import RecordNoImage from "../../../components/recordNotFound/RecordNoImage";
import { useIds } from "../../../hook/AdminContext";
import { s3baseUri } from "../../../config/config";
import { FacebookIcon } from "../../../assets/icon/FacebookIcon";
import InstagramIcon from "../../../assets/icon/InstagramIcon";
import LinkedinIcon from "../../../assets/icon/LinkedinIcon";
import { TwitterIcon } from "../../../assets/icon/TwitterIcon";
import YoutubeIcon from "../../../assets/icon/YoutubeIcon";
import TiktokIcon from "../../../assets/icon/TiktokIcon";
import RecordNotFound from "../../../components/recordNotFound/RecordNotFound";
import JobListCard from "../../../components/jobs/JobListCard";
import ManageAffiliates from "./ManageAffiliates";
import ClientAffiliates from "./ClientAffiliates";
import CustomPopoverSection from "../../../components/menu/MebuCustomPopOverSection";
import { useNavigate } from "react-router-dom";
import ClientsJobAndFeedListing from "./ClientsJobAndFeedListing";
import ClientsJobCard from "./ClientsJobCard";
import HomeForCoachAndLeader from "./profile-sections/HomeForCoachAndLeader";
import MediaSection from "./profile-sections/MediaSection";
import JobSwiper from "../../../components/CustomSwiper/JobSwiper";
import AchievementListing from "./Media/MediaListing";
import MediaSwiper from "../../../components/CustomSwiper/MediaSwiper";

export default function DetailsForCoachAndLeader({
  data,
  isCompanyProfile = false,
  companyType = "",
  isCoachModal = false,
  showSideBar = true,
  fetchDetails = () => { },
}) {
  const navigate = useNavigate();
  const { userInfo, setUpdateJobOnNotification } = useIds();
  const [cardToOpen, setCardToOpen] = useState("home");
  const [jobCardToOpen, setJobCardToOpen] = useState("list");
  const [targetJob, setTargetJob] = useState(null);
  const [jobListing, setJobListing] = useState(data?.jobs || []);

  const handleMenuList = () => {
    const Menu_List = [
      {
        title: "Home",
        value: "home",
      },
      // {
      //   title: "About",
      //   value: "about",
      // },
      {
        title: "Posts",
        value: "feed",
      },
      {
        title: "Jobs",
        value: "job",
      },
      // {
      //   title: "Achievements",
      //   value: "achievements",
      // },
      // {
      //   title: "Media",
      //   value: "media",
      // },
      {
        title: "Affiliates",
        value: "affiliates",
      },
    ];

    // if (userInfo.profile_id == data._id) {
    //   Menu_List.push({
    //     title: "Manage Affiliates",
    //     value: "manage-affiliates",
    //   });
    // }
    return Menu_List;
  };

  const handleMoveJobCandidates = (job) => {
    setCardToOpen("job");
    setJobCardToOpen("candidate_list");
    setTargetJob(job);
  };
  const handleMoveJobDetails = (job) => {
    setJobCardToOpen("job_details");
    setCardToOpen("job");
    setTargetJob(job);
  };

  const handleMoveToJobs = () => {
    setCardToOpen("job");
  };
  const handleMoveToPosts = () => {
    setCardToOpen("feed");
  };

  const handleMoveToMedia = (type) => {
    setCardToOpen(type);
  };

  const handleGetMenu = () => {
    let list = [
      {
        label: "Edit Profile",
        icon: "akar-icons:edit",
        handleClick(row) {
          navigate("/profile/edit");
        },
        red_dot: userInfo?.direct_contact_check ? true : false,
      },
    ];

    if (
      !userInfo?.isCompanyProfile ||
      (userInfo?.isCompanyProfile &&
        userInfo?.company_access?.manage_profile?.company_profile)
    ) {
      list.push({
        label: "Manage Affiliates",
        icon: "tabler:affiliate",
        handleClick(row) {
          navigate("/profile/manage-affiliate");
        },
        red_dot: userInfo?.has_pending_affiliation_request ? true : false,
      });
    }
    return list;
  };

  // useEffect(() => {
  //   const element = document.querySelector(".top-div-client-detail");
  //   if (element) {
  //     setTimeout(() => {
  //       element.scrollIntoView({ behavior: "smooth", block: "start" });
  //     }, 2000);
  //   }
  // }, [jobCardToOpen]);

  const handleUpdateSpecificJob = (updatedJob, setList = setJobListing) => {
    if (updatedJob.deleted_job_id) {
      setList((prev) =>
        prev.filter((item) => item._id != updatedJob.deleted_job_id)
      );
      return;
    }
    setList((prev) =>
      prev.map((item) =>
        item._id === updatedJob._id ? { ...item, ...updatedJob } : item
      )
    );
  };

  useEffect(() => {
    // Register the function
    setUpdateJobOnNotification((data) => {
      handleUpdateSpecificJob(data, setJobListing);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateJobOnNotification(() => { });
    };
  }, [jobListing]);

  return (
    <>
      {/* using this div for scrolling on top ref */}
      <div className="top-div-client-detail"></div>
      {/*  */}
      <div className="col-12">

        <div
          className={`row  shadow-md  ${!isCoachModal ? "pb-0" : ""
            } mb-2 client-basic-info-card`}
        >
          <div className="col-lg-6">
            <div className="d-flex justify-content-between">
              <div className="client-image-wrapper !tw-relative tw-top-0 tw-left-0">
                {data.profile_image?.thumbnail_2 ||
                  data.profile_image?.thumbnail_1 ? (
                  <img
                    src={
                      data.profile_image?.thumbnail_2
                        ? s3baseUri + data.profile_image?.thumbnail_2
                        : s3baseUri + data.profile_image?.thumbnail_1
                    }
                    alt={data.company_name + " Logo"}
                    className="rounded-3 shadow-sm img-fluid"
                  />
                ) : (
                  <RecordNoImage title={data?.company_name + " Logo"} />
                )}
              </div>

              {userInfo.profile_id == data._id &&
                (!userInfo?.isCompanyProfile ||
                  (userInfo?.isCompanyProfile &&
                    userInfo?.company_access?.manage_profile
                      ?.company_profile)) && (
                  <div
                    style={{ position: "relative", display: "inline-block" }}
                  >
                    <CustomPopoverSection menu={handleGetMenu()} data={data} />


                    {userInfo?.direct_contact_check ||
                      userInfo?.has_pending_affiliation_request ? (
                      <span
                        style={{
                          position: "absolute",
                          top: "-4px",
                          right: "-4px",
                          width: "10px",
                          height: "10px",
                          backgroundColor: "red",
                          borderRadius: "50%",
                          border: "2px solid white",
                        }}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                )}
            </div>
            <div className={`info-block ${isCoachModal ? "mb-0" : ""}`}>
              <h6>
                {isCoachModal
                  ? data.contact_name || data.leader_title || data?.name
                  : data?.company_name}
              </h6>
              <span className="!tw-text-sm">{data?.location}</span>
            </div>

          </div>
          <div className="col-lg-6"> {cardToOpen == "home" && (
            <HomeForCoachAndLeader
              data={data}
              isCoachModal={isCoachModal}
              isCompanyProfile={isCompanyProfile}
              companyType={companyType}
              // job data props
              setJobListing={setJobListing}
              fetchDetails={fetchDetails}
              handleMoveJobCandidates={handleMoveJobCandidates}
              handleMoveJobDetails={handleMoveJobDetails}
              handleMoveToMedia={handleMoveToMedia}
              handleMoveToJobs={handleMoveToJobs}
              handleMoveToPosts={handleMoveToPosts}
            // -- IGNORE --
            />
          )}</div>
          {!isCoachModal && (
            <div className="menu-block">
              {handleMenuList().map((item) => (
                <span
                  className={`menu-item pb-2 ${cardToOpen == item.value ? "active" : ""
                    }`}
                  onClick={() => {
                    setCardToOpen(item.value);
                    if (item.value == "job") {
                      setJobCardToOpen("list");
                      setTargetJob(null);
                    }
                  }}
                >
                  {item.title}
                </span>
              ))}
            </div>
          )}
        </div>
        {(data.about || data.description || data.leader_description) && (
          <div className="card shadow-md p-4 mt-2 mb-2 about-content">
            <label className="label-style mb-2">
              {isCoachModal ? "Description" : "About"}
            </label>
            <p
              className="ps-2 ckeditor tinymce-reset"
              dangerouslySetInnerHTML={{
                __html: data.about || data.description || data.leader_description,
              }}
            ></p>
          </div>
        )}
        {/* SHORT SUMMARY */}
        {(data?.[companyType]?.short_summary ||
          data?.leader_short_summary ||
          data?.short_summary) &&
          (isCompanyProfile || isCoachModal) && (
            <div className="card shadow-md p-4 mt-2 mb-2 about-content">
              <label className="label-style mb-2">Short Summary</label>
              <p className="ps-2 ckeditor tinymce-reset">
                {data?.[companyType]?.short_summary ||
                  data.short_summary ||
                  data?.leader_short_summary ||
                  ""}
              </p>
            </div>
          )}



        {(cardToOpen == "job" || cardToOpen == "feed") && (
          <ClientsJobAndFeedListing
            type={cardToOpen}
            handleBack={() => {
              setCardToOpen("job");
              setJobCardToOpen("list");
            }}
            clientId={data._id}
            handleMoveJobCandidates={handleMoveJobCandidates}
            handleMoveJobDetails={handleMoveJobDetails}
            jobCardToOpen={jobCardToOpen}
            targetJob={targetJob}
            setJobCardToOpen={setJobCardToOpen}
          />
        )}
        {cardToOpen == "affiliates" && (
          <ClientAffiliates clientId={data._id} />
        )}
        {/* {cardToOpen === "achievements" && (
            <MediaSection mediaType="achievement" profile_user_id={data._id} />
          )} */}

        {/* {cardToOpen === "media" && (
            <MediaSection mediaType="media" profile_user_id={data._id} />
          )} */}
        {/* {cardToOpen == "manage-affiliates" && (
            <>
              <ManageAffiliates />
            </>
          )} */}

        {cardToOpen == "home" && showSideBar && (
          <div>
            <div className="clients-sidebar d-none">
              <div className="shadow-md about-content">
                {/* job */}
                <div className="card">
                  <div className="d-flex justify-content-between align-items-center pt-2 px-3">
                    <h6 className="fw-bold mb-0">Company Jobs</h6>
                    <button
                      className="btn-outlined-sm"
                      onClick={() => {
                        setCardToOpen("job");
                      }}
                    >
                      View All
                    </button>
                  </div>
                  <div className="p-3 pb-0">
                    <JobSwiper
                      slidesPerView={1}
                      data={data.jobs}
                      setJobListing={setJobListing}
                      fetchDetails={fetchDetails}
                      handleMoveJobCandidates={handleMoveJobCandidates}
                      handleMoveJobDetails={handleMoveJobDetails}
                    ></JobSwiper>
                  </div>
                </div>
                {/* Achievement */}
                <div className="card mt-2">
                  <div className="p-3 pb-0">
                    <AchievementListing
                      viewType="slider"
                      mediaType="achievement"
                      media={data.achievements}
                      handleUploadComplete={fetchDetails}
                      handleViewAllClick={handleMoveToMedia}
                      profile_user_id={data._id}
                    />
                  </div>
                </div>
                {/* Media */}
                <div className="card mt-2">
                  <div className="p-3 pb-0">
                    <AchievementListing
                      viewType="slider"
                      mediaType="media"
                      media={data.media}
                      handleUploadComplete={fetchDetails}
                      handleViewAllClick={handleMoveToMedia}
                      profile_user_id={data._id}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/*  */}

            <div className="right-side-job-listing clients-sidebar">
              <div
                className="col-12 px-3 pb-3 border-bottom d-flex flex-wrap align-items-center justify-content-between  p-2 margin-lef-right "
                style={{
                  width: "100%",
                  marginRight: "2px",
                  overflow: "hidden",
                  marginLeft: "0px !important",
                }}
              >
                <h4
                  className="groups-text mb-2"
                  style={{
                    fontSize: "16px",
                    fontWeight: "bold",
                    marginLeft: "0",
                    flex: "1 1 auto",
                  }}
                >
                  Company Jobs
                </h4>

                <button
                  className="outlined-btn h-auto"
                  onClick={() => {
                    setCardToOpen("job");
                  }}
                >
                  View All
                </button>
              </div>

              <div
                className="no-scrollbar"
                style={{
                  width: "100%",
                  padding: "12px",
                  overflowY: "auto",
                  WebkitOverflowScrolling: "touch",
                  // zoom effect change
                  height: "calc(107vh - 185px)",
                }}
              >
                {jobListing?.length > 0 ? (
                  jobListing.map((job) => (
                    <ClientsJobCard
                      job={job}
                      setListing={setJobListing}
                      fetchDetails={fetchDetails}
                      handleMoveJobCandidates={handleMoveJobCandidates}
                      handleMoveJobDetails={handleMoveJobDetails}
                    />
                  ))
                ) : (
                  <div className="mt-5">
                    <RecordNoImage title="No Jobs Found" />
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
